module.exports = __webpack_public_path__ + "img/CompatibleDevices.ae004459.png";